import React from "react";
import { Form, Header, Grid, Segment, Message, Button } from "semantic-ui-react";
import { formatCurrency } from "../../../utils/constants";

function Verify(props) {
    const {
        values,
        nonProfits,
        games,
        campaigns,
        pricingData,
        customWebPricingEnabled,
        pricepointLabelsEnabled,
        xhrEventId,
        dynamicPPTimeOverlap,
        calendarStartDateError,
        NonAddOnEventList,
        config } = props;
    let defaultTablet = [];
    let defaultWeb = [];
    let isExpense = false;
    if (!(+values.expense_flat === 0 && +values.expense_cc_percent === 0 && +values.expense_cc_trans === 0 && (+values.expense_venue_total === 0 || +values.expense_venue_jackpot === 0))) {
        isExpense = true;
    }
    pricingData["default"].forEach(ppR => {
        if (ppR['type'] === "web") {
        defaultWeb.push(ppR);
        } else {
        defaultTablet.push(ppR);
        }
    });
    const parentEvent = NonAddOnEventList.find(
        event => event.id === values.parent_id
    );
    const gameType = games.filter(function (el) {
        return el != null;
    }).find(game => game.id === values.game_id);
    const nonProfitName = nonProfits.find(
        nonProfit => nonProfit.id === values.nonprofit_id
    );
    const active_campaigns = [];
    campaigns.map((v, k) => {
        if (+values.campaigns.indexOf(+v.id) !== -1) {
        active_campaigns.push(v.text);
        }
        return true;
    });
    const TabletPP = () => {
        let listTabletPP = [];
        for (let id = 0; id < defaultTablet.length; id++) {
        listTabletPP.push(<span className={defaultTablet[id] && defaultTablet[id].highlight ? "highlightPricePoint" : ""}>
            {defaultTablet[id] && defaultTablet[id].quantity && defaultTablet[id].quantity !== "" &&
            `${defaultTablet[id].quantity} for ${formatCurrency(defaultTablet[id].price, config.language)}`}
            {+pricepointLabelsEnabled > 0 && defaultTablet[id].label && defaultTablet[id].label !== "" &&
            <span>{` - ${defaultTablet[id].label}`}</span>
            }
        </span>);
        if (id !== defaultTablet.length - 1) listTabletPP.push(<br />);
        }
        return listTabletPP;
    }
    const WebPP = () => {
        let listWebPP = [];
        for (let id = 0; id < defaultWeb.length; id++) {
        listWebPP.push(<span className={defaultWeb[id] && defaultWeb[id].highlight ? "highlightPricePoint" : ""}>
            {defaultWeb[id] && defaultWeb[id].quantity && defaultWeb[id].quantity !== "" &&
            `${defaultWeb[id].quantity} for ${formatCurrency(defaultWeb[id].price, config.language)}`}
            {+pricepointLabelsEnabled > 0 && defaultWeb[id].label && defaultWeb[id].label !== "" &&
            <span>{` - ${defaultWeb[id].label}`}</span>
            }
        </span>);
        if (id !== defaultWeb.length - 1) listWebPP.push(<br />);
        }
        return listWebPP;
    }
    const DynamicTabletPP = (props) => {
        let key = props.index;
        let dynamicTablet = [];
        pricingData['dynamic'][key].pricepoints.forEach(pp => {
        if (pp['type'] === "tablet") {
            dynamicTablet.push(pp);
        }
        });
        let listDynamicTabletPP = [];
        for (let id = 0; id < dynamicTablet.length; id++) {
        listDynamicTabletPP.push(<span className={pricingData['dynamic'][key] && dynamicTablet[id] && dynamicTablet[id].highlight ? "highlightPricePoint" : ""}>
            {pricingData['dynamic'][key] && dynamicTablet[id] && dynamicTablet[id].quantity !== "" &&
            `${dynamicTablet[id].quantity} for ${formatCurrency(dynamicTablet[id].price, config.language)}`}
            {+pricepointLabelsEnabled > 0 && dynamicTablet[id].label && dynamicTablet[id].label !== "" &&
            <span>{` - ${dynamicTablet[id].label}`}</span>
            }
        </span>);
        if (id !== dynamicTablet.length - 1) listDynamicTabletPP.push(<br />);
        }
        return listDynamicTabletPP;
    }
    const DynamicWebPP = (props) => {
        let key = props.index;
        let dynamicWeb = [];
        pricingData['dynamic'][key].pricepoints.forEach(pp => {
        if (pp['type'] === "web") {
            dynamicWeb.push(pp);
        }
        });
        let listDynamicWebPP = [];
        for (let id = 0; id < dynamicWeb.length; id++) {
        listDynamicWebPP.push(<span className={pricingData['dynamic'][key] && dynamicWeb[id] && dynamicWeb[id].highlight ? "highlightPricePoint" : ""}>
            {pricingData['dynamic'][key] && dynamicWeb[id] && dynamicWeb[id].quantity !== "" &&
            `${dynamicWeb[id].quantity} for ${formatCurrency(dynamicWeb[id].price, config.language)}`}
            {+pricepointLabelsEnabled > 0 && dynamicWeb[id].label && dynamicWeb[id].label !== "" &&
            <span>{` - ${dynamicWeb[id].label}`}</span>
            }
        </span>);
        if (id !== dynamicWeb.length - 1) listDynamicWebPP.push(<br />);
        }
        return listDynamicWebPP;
    }
    let pricingCardDisplayFlag = true;
    let pricingCardTitleFlag = false;
    if (+values.webenabled > 0 || +values.shopify_enabled > 0) {
        pricingCardDisplayFlag = +customWebPricingEnabled === 0 ? false : true;
        pricingCardTitleFlag = +customWebPricingEnabled === 0 ? true : false;
    } else {
        pricingCardDisplayFlag = false;
    }
    return (
        <Form size="large">
        {dynamicPPTimeOverlap && <Message
            negative
            content={"Overlapping dynamic price time ranges detected, please resolve to continue."}
        />}
        {calendarStartDateError && <Message
            negative
            content={"Calendar raffle start date must be set to today's date or a future date, please resolve to continue."}
        />}
        <p>
            Please confirm the settings for your event below are correct. You will
            not be able to change these settings once the event is live!
        </p>

        <Header>
            {values.title}
            <Header.Subheader>{values.start_at} - {values.end_at}</Header.Subheader>
            <Header.Subheader>Draw Date Text: {values.draw_at_text}</Header.Subheader>
        </Header>

        {+active_campaigns.length > 0 && (<p><b>Campaign(s):</b></p>)}

        {+active_campaigns.length > 0 && active_campaigns.map((v, k) => (<div>{v}</div>))}

        {+values.is_import_raffle > 0 && <p><b>This is an Import raffle.</b></p>}

        {+values.prize_imports_enabled > 0 && <p><b>Prize Imports enabled.</b></p>}

        <p><b>Game Type:</b> {gameType && gameType.title}</p>

        {config.addons_enabled && values.game_id !== 3 && values.parent_id && parentEvent && (<p><b>Add-on Event for:</b> {parentEvent.title}</p>)}

        <p><b>Non-Profit:</b> {nonProfitName && nonProfitName.text}</p>

        {+values.rsu_enabled > 0 && !values.is_import_raffle && (<p><b>RSU is enabled.</b></p>)}

        {+values.webenabled > 0 && !values.is_import_raffle && (<p><b>Bump E-Commerce is enabled.</b></p>)}

        {+values.shopify_enabled > 0 && !values.is_import_raffle && (<p><b>Bump Shopify is enabled.</b></p>)}

        {+values.event_subscription_group_id > 0 && (<p><b>Subscription Enabled.</b></p>)}

        {values.game_id === 4 && +values.calendar_jackpot > 0 && (<p><b>Amount per draw:</b> ${values.calendar_jackpot}</p>)}

        {values.game_id !== 2 && values.game_id !== 4 && +values.jackpot_start > 0 && !values.is_import_raffle && (<p><b>Guaranteed Jackpot:</b> ${values.jackpot_start}</p>)}

        {values.game_id !== 2 && values.game_id !== 4 && +values.sweetenpot > 0 && !values.is_import_raffle && (<p><b>Sweetened Jackpot:</b> ${values.sweetenpot}</p>)}

        {!values.is_import_raffle &&
        <>
            <Header as="h4">Ticket Prices:</Header>
            <Grid columns={3} stackable>
                <Grid.Row stretched>
                <Grid.Column>
                    <Segment textAlign="left"><Form.Field inline><b>Time:</b><label>Default</label></Form.Field></Segment>
                </Grid.Column>
                <Grid.Column>
                    <Segment textAlign="left">
                    <b>{pricingCardTitleFlag ? "Tablet & Web:" : "Tablet:"}</b><br />
                    {!props.values.rsu_enabled ? <WebPP /> : <TabletPP />}
                    </Segment>
                </Grid.Column>
                {pricingCardDisplayFlag && (
                    <Grid.Column>
                    <Segment textAlign="left">
                        <b>Web:</b><br />
                        {+customWebPricingEnabled > 0 ? <WebPP /> : <TabletPP />}
                    </Segment>
                    </Grid.Column>
                )}
                </Grid.Row>
            </Grid>
            {Object.keys(pricingData["dynamic"]).length > 0 && (
                <Header as="h4">Dynamic Pricing:</Header>
            )}
            {Object.keys(pricingData["dynamic"]).length > 0 && (
                <Grid columns={3} stackable>
                {Object.keys(pricingData['dynamic']).map((v, k) => {
                    return (
                    <Grid.Row key={k} stretched>
                        <Grid.Column>
                        <Segment textAlign="left">
                            <Form.Field inline>
                            <b>Time:</b>
                            <label>
                                {`${pricingData['dynamic'][k].start} to ${pricingData['dynamic'][k].end}`}
                            </label>
                            </Form.Field>
                        </Segment>
                        </Grid.Column>
                        <Grid.Column>
                        <Segment textAlign="left">
                            <b>{pricingCardTitleFlag ? "Tablet & Web:" : "Tablet:"}</b><br />
                            {!props.values.rsu_enabled ? <DynamicWebPP key={k} index={k} /> : <DynamicTabletPP key={k} index={k} />}
                        </Segment>
                        </Grid.Column>
                        {pricingCardDisplayFlag && (
                        <Grid.Column>
                            <Segment textAlign="left">
                            <b>Web:</b><br />
                            {+customWebPricingEnabled > 0 ? <DynamicWebPP key={k} index={k} /> : <DynamicTabletPP key={k} index={k} />}
                            </Segment>
                        </Grid.Column>
                        )}
                    </Grid.Row>
                    );
                })}
                </Grid>
            )}
        </>}

        {isExpense && !values.is_import_raffle &&
            <>
                <Header as="h4">Expenses</Header>
                <p>
                    {+values.expense_flat !== 0 &&
                    `Subtract a rate of ${values.expense_flat}% from all sales.`}
                    {+values.expense_flat !== 0 && <br />}

                    {+values.expense_cc_percent !== 0 &&
                    `Subtract a rate of ${values.expense_cc_percent}% from credit/debit card sales.`}
                    {+values.expense_cc_percent !== 0 && <br />}

                    {+values.expense_cc_trans !== 0 &&
                    `Subtract a flat amount of $${values.expense_cc_trans} from each credit/debit card sale.`}
                    {+values.expense_cc_trans !== 0 && <br />}

                    {(+values.expense_venue_total !== 0 && +values.expense_venue_jackpot !== 0) &&
                    `Gradually subtract $${values.expense_venue_total} until the jackpot reaches $${values.expense_venue_jackpot}`}
                    {(+values.expense_venue_total !== 0 && +values.expense_venue_jackpot !== 0) && <br />}
                </p>
            </>
        }

        <Button
            type="button"
            primary
            size="large"
            content="Save And Finish"
            onClick={() => props.handleStep("submit")}
            disabled={+xhrEventId > 0 || dynamicPPTimeOverlap || calendarStartDateError}
            floated="right"
        />
        <Button
            type="button"
            size="large"
            content="Go Back"
            size="large"
            onClick={() => props.handleStep(`${values.is_import_raffle ? 'non-profit' : 'expenses'}`)}
            floated="right"
        />

        </Form>
    );
}

export default Verify;
